export enum PropertyType {
  Null = 'null',
  String = 'string',
  Integer = 'integer',
  Boolean = 'boolean',
  Array = 'array',
  Number = 'number',
  Object = 'object',
  Date = 'date',
  Enum = 'enum'
};
